import { render, staticRenderFns } from "./QuizByKtiGrid.vue?vue&type=template&id=e6c40aea"
import script from "./QuizByKtiGrid.vue?vue&type=script&lang=js"
export * from "./QuizByKtiGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports